export const toNumberOrUndefined = (value: number | string): number | undefined => {
  if (value === '' || value === null || value === undefined) return undefined;
  const num = typeof value === 'string' ? Number.parseInt(value, 10) : value;
  return Number.isNaN(num) ? undefined : num;
};

export const fromNumberOrUndefined = (value: number | undefined): number | string => {
  return value ?? '';
};

export const sanitizeIntegerInput = (value: string): number => {
  const digitsOnly = value.replace(/\D+/g, '');

  if (!digitsOnly) return 0;

  return Number.parseInt(digitsOnly, 10);
};
